export interface VideoPlayerDataType {
  loaded: boolean;
  options: any;
}

export const videoMimeTypes: any = {
  'x-msvideo': 'video/x-msvideo',
  avi: 'video/avi',
  msvideo: 'video/msvideo',
  quicktime: 'video/quicktime',
  raw: 'video/raw',
  mpeg: 'video/mpeg',
  'x-ms-wmv': 'video/x-ms-wmv',
  mp4: 'video/mp4',
  ogg: 'video/ogg',
  webm: 'video/webm',
};
